import React, { useState } from "react";
import axios from "axios";
import Barcode from "react-barcode";
import SearchIcon from "@mui/icons-material/Search";
import QrCodeIcon from "@mui/icons-material/QrCode";
import ClearIcon from "@mui/icons-material/Clear";
import config from "../config";

function QrLookupPopup() {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [qrCodeData, setQrCodeData] = useState(null);
  const [guestVoucherInfo, setGuestVoucherInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  // Function to generate QR code data string
  const generateQrCodeString = (guestInfo, vouchers) => {
    if (!guestInfo || !vouchers || vouchers.length === 0) return "";
    
    // Find the voucher with the highest ID (latest voucher)
    const latestVoucher = vouchers.reduce((latest, current) => {
      return current.id > latest.id ? current : latest;
    });
    
    return latestVoucher.voucherCode;
  };

  // Function to search vouchers by phone number
  const searchVouchersByPhone = async () => {
    if (!phoneNumber.trim()) {
      alert("Vui lòng nhập số điện thoại");
      return;
    }
    let validPhoneNumber = phoneNumber.trim();
    if (validPhoneNumber.startsWith('0')) {
      validPhoneNumber = validPhoneNumber.replace('0', '84');
    }

    setLoading(true);
    const token = localStorage.getItem('token');
    
    try {
      const response = await axios.get(
        `${config.apiEndpoint}/Voucher/by-phone/${validPhoneNumber}`,
        { 
          headers: token ? { Authorization: `Bearer ${token}` } : {}, 
          withCredentials: true 
        }
      );

      if (response.status === 200) {
        setGuestVoucherInfo(response.data);
        const qrString = generateQrCodeString(response.data.guestInfo, response.data.vouchers);
        setQrCodeData(qrString);
        console.log("Voucher data retrieved successfully:", response.data);
      }
    } catch (err) {
      console.error("Error fetching vouchers by phone:", err);
      alert("Không tìm thấy thông tin voucher cho số điện thoại này");
      setGuestVoucherInfo(null);
      setQrCodeData(null);
    } finally {
      setLoading(false);
    }
  };

  const clearSearch = () => {
    setPhoneNumber("");
    setQrCodeData(null);
    setGuestVoucherInfo(null);
  };

  return (
    <div style={{
      width: "100%",
      height: "100vh",
      backgroundColor: "#f5f5f5",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    }}>
      {/* Header */}
      <div style={{
        background: "linear-gradient(135deg, #007bff 0%, #0056b3 100%)",
        padding: "12px 15px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
      }}>
        <QrCodeIcon style={{ color: "#fff", fontSize: "22px" }} />
        <span style={{ color: "#fff", fontWeight: "600", fontSize: "16px" }}>
          Tra cứu Barcode
        </span>
      </div>

      {/* Content */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        {/* Search Section */}
        <div style={{ 
          padding: "15px", 
          backgroundColor: "#fff",
          borderBottom: "1px solid #eee",
          boxShadow: "0 2px 5px rgba(0,0,0,0.05)"
        }}>
          <div style={{ display: "flex", gap: "8px" }}>
            <input
              type="text"
              placeholder="Nhập số điện thoại..."
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  searchVouchersByPhone();
                }
              }}
              style={{
                flex: 1,
                padding: "12px 14px",
                fontSize: "14px",
                border: "2px solid #e1e5e9",
                borderRadius: "8px",
                outline: "none",
                transition: "border-color 0.2s"
              }}
              onFocus={(e) => e.target.style.borderColor = "#007bff"}
              onBlur={(e) => e.target.style.borderColor = "#e1e5e9"}
            />
            <button
              onClick={searchVouchersByPhone}
              disabled={loading}
              style={{
                padding: "12px 18px",
                backgroundColor: loading ? "#ccc" : "#007bff",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                cursor: loading ? "not-allowed" : "pointer",
                fontSize: "14px",
                fontWeight: "500",
                display: "flex",
                alignItems: "center",
                gap: "5px",
                transition: "background-color 0.2s",
                whiteSpace: "nowrap"
              }}
            >
              <SearchIcon style={{ fontSize: "18px" }} />
              {loading ? "..." : "Search"}
            </button>
            {(qrCodeData || phoneNumber) && (
              <button
                onClick={clearSearch}
                title="Xóa"
                style={{
                  padding: "12px",
                  backgroundColor: "#dc3545",
                  color: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "background-color 0.2s"
                }}
              >
                <ClearIcon style={{ fontSize: "18px" }} />
              </button>
            )}
          </div>
        </div>

        {/* Result Section */}
        <div style={{ 
          flex: 1, 
          overflow: "auto", 
          padding: "15px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }}>
          {/* Loading */}
          {loading && (
            <div style={{ 
              display: "flex", 
              alignItems: "center", 
              justifyContent: "center",
              height: "100%",
              color: "#666"
            }}>
              <div style={{
                width: "35px",
                height: "35px",
                border: "3px solid #f3f3f3",
                borderTop: "3px solid #007bff",
                borderRadius: "50%",
                animation: "spin 1s linear infinite"
              }} />
              <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
            </div>
          )}

          {/* Guest Info */}
          {!loading && guestVoucherInfo && (
            <div style={{ width: "100%", marginBottom: "15px" }}>
              <div style={{
                backgroundColor: "#fff",
                padding: "14px",
                borderRadius: "10px",
                fontSize: "13px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                border: "1px solid #e9ecef"
              }}>
                <p style={{ margin: "5px 0", display: "flex", alignItems: "center", gap: "8px" }}>
                  <span style={{ fontSize: "16px" }}>👤</span>
                  <strong>{guestVoucherInfo.guestInfo.name}</strong>
                </p>
                <p style={{ margin: "5px 0", display: "flex", alignItems: "center", gap: "8px" }}>
                  <span style={{ fontSize: "16px" }}>📞</span>
                  <span>{guestVoucherInfo.guestInfo.phoneNumber}</span>
                </p>
                <p style={{ margin: "5px 0", display: "flex", alignItems: "center", gap: "8px" }}>
                  <span style={{ fontSize: "16px" }}>⭐</span>
                  <span style={{ color: "#007bff", fontWeight: "600" }}>
                    {guestVoucherInfo.guestInfo.point?.toLocaleString('vi-VN')} điểm
                  </span>
                </p>
              </div>
            </div>
          )}

          {/* Barcode Display */}
          {!loading && qrCodeData && (
            <div style={{
              width: "100%",
              padding: "20px",
              backgroundColor: "#fff",
              borderRadius: "12px",
              border: "2px solid #28a745",
              boxShadow: "0 4px 15px rgba(40,167,69,0.15)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center"
            }}>
              <h4 style={{
                margin: "0 0 15px 0",
                color: "#28a745",
                fontSize: "15px",
                fontWeight: "600",
                display: "flex",
                alignItems: "center",
                gap: "8px"
              }}>
                <span>📊</span> Mã Barcode
              </h4>
              <div style={{
                backgroundColor: "#fff",
                padding: "10px",
                borderRadius: "8px",
                border: "1px solid #eee"
              }}>
                <Barcode 
                  value={qrCodeData}
                  width={1.8}
                  height={70}
                  fontSize={11}
                  margin={8}
                  background="#ffffff"
                  lineColor="#000000"
                  displayValue={false}
                />
              </div>
              <p style={{
                fontSize: "10px",
                color: "#666",
                marginTop: "12px",
                textAlign: "center",
                wordBreak: "break-all",
                padding: "8px 12px",
                backgroundColor: "#f8f9fa",
                borderRadius: "6px",
                maxWidth: "100%",
                fontFamily: "monospace",
                border: "1px solid #e9ecef"
              }}>
                {qrCodeData}
              </p>
            </div>
          )}

          {/* Empty State */}
          {!loading && !qrCodeData && (
            <div style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              color: "#999",
              textAlign: "center",
              padding: "30px"
            }}>
              <QrCodeIcon style={{ fontSize: "60px", opacity: 0.2, marginBottom: "15px", color: "#007bff" }} />
              <p style={{ fontSize: "14px", margin: "0 0 5px 0", color: "#666" }}>
                Tra cứu Barcode
              </p>
              <p style={{ fontSize: "12px", margin: 0, color: "#999" }}>
                Nhập số điện thoại để tìm kiếm
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default QrLookupPopup;
